import logo_tipddy from "./assets/logo-tipddy.png";
import "./index.css";
import { useTheme } from "../../contexts/ThemeContext";
import { Link } from "react-router-dom";
import { useConfig } from "../../contexts/config";
import React from "react";
import { readableColor } from "polished";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LanguageIcon from "@mui/icons-material/Language";

export const Footer = () => {
  const { config } = useConfig();
  const theme = useTheme();
  const [contrastColorSecondary, setcontrastColorSecondary] =
    React.useState("#fff");

  React.useEffect(() => {
    if (theme && theme.colors.backgroundColorFooter) {
      setcontrastColorSecondary(
        readableColor(theme.colors.backgroundColorFooter, "#000", "#fff", false)
      );
    }
  }, [theme]);

  // Si el texto es blanco (fondo oscuro), invertimos el logo principal a blanco si no estamos ya en dark mode
  // y también invertimos el logo de Tipddy.
  const logoFilter = theme.mode === 'dark' ? 'none' : (contrastColorSecondary === '#fff' ? 'brightness(0) invert(1)' : 'none');
  const tipddyFilter = contrastColorSecondary === '#fff' ? 'brightness(0) invert(1)' : 'brightness(0)';

  return (
    <footer
      style={{ backgroundColor: theme.colors.backgroundColorFooter, color: contrastColorSecondary }}
      className="footer-main pt-10 pb-6 px-6 tablet:px-12 font-jost"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col laptop:flex-row justify-between items-center laptop:items-start gap-8 laptop:gap-12 w-full">

          {/* Column 1: Identity & Contact */}
          <div className="flex flex-col items-center laptop:items-start gap-3 w-full laptop:w-1/4">
            <div className="w-40 mb-1">
              <img
                src={
                  config.config.theme &&
                  (theme && theme.mode === "light"
                    ? config.config.theme.logo
                    : config.config.theme.theme_logo_dark)
                }
                alt="Logo Decidido"
                className="w-full h-auto object-contain"
                style={{ filter: logoFilter }}
              />
            </div>
            <div className="flex flex-col gap-3 opacity-80 text-[13px] items-center laptop:items-start mt-4">
              <a href="mailto:contacto@decidido.cl" className="flex items-center gap-2 hover:opacity-100 transition-opacity">
                <EmailIcon sx={{ fontSize: 16 }} />
                contacto@decidido.cl
              </a>
              <div className="flex items-center gap-2">
                <LocationOnIcon sx={{ fontSize: 16 }} />
                Las Condes, Santiago - CL
              </div>
            </div>
          </div>

          {/* Column 2: Ecosystem (Compact Grid) */}
          <div className="flex flex-col items-center laptop:items-start w-full laptop:w-2/4">
            <h3 className="text-[14px] font-semibold opacity-70 uppercase tracking-widest mb-6 w-full text-center laptop:text-left border-y border-white/10 py-3">Nuestras Plataformas</h3>
            <div className="grid grid-cols-1 tablet:grid-cols-2 gap-x-6 gap-y-6 w-full">
              {/* Brand 1 */}
              <div className="flex flex-col gap-1 text-[13px]">
                <a href="https://www.serviciosdecidido.cl" target="_blank" rel="noreferrer" className="font-semibold hover:underline flex items-center gap-2">
                  <LanguageIcon sx={{ fontSize: 15 }} /> Servicios decidido!
                </a>
                <a href="https://www.instagram.com/serviciosdecidido" target="_blank" rel="noreferrer" className="text-[12px] opacity-70 hover:opacity-100 flex items-center gap-2">
                  <InstagramIcon sx={{ fontSize: 13 }} /> @serviciosdecidido
                </a>
              </div>
              {/* Brand 2 */}
              <div className="flex flex-col gap-1 text-[13px]">
                <a href="https://www.decididoeducacion.cl" target="_blank" rel="noreferrer" className="font-semibold hover:underline flex items-center gap-2">
                  <LanguageIcon sx={{ fontSize: 15 }} /> Decidido! Educación
                </a>
                <a href="https://www.instagram.com/decididoeducacion/" target="_blank" rel="noreferrer" className="text-[12px] opacity-70 hover:opacity-100 flex items-center gap-2">
                  <InstagramIcon sx={{ fontSize: 13 }} /> @decididoeducacion
                </a>
              </div>
              {/* Brand 3 */}
              <div className="flex flex-col gap-1 text-[13px]">
                <a href="https://www.decididocapacita.cl" target="_blank" rel="noreferrer" className="font-semibold hover:underline flex items-center gap-2">
                  <LanguageIcon sx={{ fontSize: 15 }} /> OTEC Decidido! capacita
                </a>
                <a href="https://www.instagram.com/otecdecididocapacita/" target="_blank" rel="noreferrer" className="text-[12px] opacity-70 hover:opacity-100 flex items-center gap-2">
                  <InstagramIcon sx={{ fontSize: 13 }} /> @otecdecididocapacita
                </a>
              </div>
              {/* Brand 4 */}
              <div className="flex flex-col gap-1 text-[13px]">
                <a href="https://www.decididachile.cl" target="_blank" rel="noreferrer" className="font-semibold hover:underline flex items-center gap-2">
                  <LanguageIcon sx={{ fontSize: 15 }} /> Decidida!
                </a>
                <a href="https://www.instagram.com/decididachile/" target="_blank" rel="noreferrer" className="text-[12px] opacity-70 hover:opacity-100 flex items-center gap-2">
                  <InstagramIcon sx={{ fontSize: 13 }} /> @decididachile
                </a>
              </div>
            </div>
          </div>

          {/* Column 3: Quick Links */}
          <div className="flex flex-col items-center laptop:items-end w-full laptop:w-1/4">
            <h3 className="text-[14px] font-semibold opacity-70 uppercase tracking-widest mb-6 w-full text-right border-y border-white/10 py-3">Accesos Directos</h3>
            <ul className="flex flex-col gap-4 items-center laptop:items-end text-[13px] opacity-80">
              <li>
                <Link to="/" className="hover:underline hover:opacity-100 transition-all font-medium">Inicio</Link>
              </li>
              <li>
                <Link to="/listcourses/progress" className="hover:underline hover:opacity-100 transition-all font-medium">Mi Historial</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-4 mt-6 border-t border-white/10 flex flex-col tablet:flex-row justify-between items-center gap-4 opacity-70 text-[12px]">
          <div className="flex items-center gap-2 font-medium">
            <span>DECIDIDO ® | 2013 - 2026</span>
          </div>

          <div className="flex items-center gap-2 font-medium">
            <img
              src={logo_tipddy}
              alt="Tipddy Logo"
              className="h-4 w-auto object-contain"
              style={{ filter: tipddyFilter }}
            />
            <p>
              &copy; {new Date().getFullYear()} Powered by Tipddy
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
